import { FC } from 'react';

import { IconProps } from '../../types/icon.types';

export const Lock: FC<IconProps> = ({ width = 10, height = 13, fillBg = 'transparent', fill = '#fff' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="10" height="13" rx="10" fill={fillBg} />
      <path
        d="M8.53259 4.53779H7.36905V2.64704C7.36905 1.18512 6.15355 0 4.65414 0C3.15473 0 1.93922 1.18512 1.93922 2.64704V4.53779H0.77569C0.346888 4.53779 0 4.876 0 5.29408V11.3445C0 11.7625 0.346888 12.1008 0.77569 12.1008H8.53259C8.96139 12.1008 9.30828 11.7625 9.30828 11.3445V5.29408C9.30828 4.876 8.96139 4.53779 8.53259 4.53779ZM5.23591 8.50441V9.26465C5.23591 9.57775 4.97543 9.83187 4.65414 9.83187C4.33285 9.83187 4.07237 9.57775 4.07237 9.26465V8.50441C3.83796 8.33183 3.68453 8.06047 3.68453 7.75205C3.68453 7.22975 4.11845 6.80668 4.65414 6.80668C5.18983 6.80668 5.62375 7.22975 5.62375 7.75205C5.62375 8.06047 5.47032 8.33198 5.23591 8.50441ZM5.81767 4.53779H3.4906V2.64704C3.4906 2.02052 4.01171 1.5126 4.65414 1.5126C5.29657 1.5126 5.81767 2.02052 5.81767 2.64704V4.53779Z"
        fill={fill}
      />
    </svg>
  );
};
